import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ajaxService from "../../../services/ajax-service";
import Dropdown from 'react-multilevel-dropdown';
import { Link } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Deals from "./Deals";
import { createSlug, getCategoryName } from "../../../utils";
import { Typography } from "@mui/material";

const   Categories = () => {
    const { t, i18n } = useTranslation();

    const [categories, setCategories] = useState([]);
    const [categoryOpen, setCategoryOpen] = useState(false);
    const [dropdownKey, setDropdownKey] = useState(0);

    const loadCategories = async () => {
        const { success, data } = await ajaxService.get('/all-categories');
        if (success) {
            setCategories(data);
        }
    };

    useEffect(() => {
        loadCategories();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (categoryOpen) {
                setCategoryOpen(false);
                setDropdownKey(prev => prev + 1);
            }
        };

        window.addEventListener('scroll', handleScroll, { passive: true });
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [categoryOpen]);

    const childCategories = (parentSlug, childrens) => (
        childrens.length > 0 && (
            <Dropdown.Submenu position="right" className="border-b-[3px] rounded-b-md bg-[#f1f1f1]" style={{ width: '150%'}}>
             
                {childrens.map((child, index) => {
                    const childSlug = child.slug || createSlug(child.name);
                    return (
                        <Dropdown.Item key={`child-${index}`} className="flex items-center justify-between gap-x-14">
                            <Link to={`/category/${parentSlug}/${childSlug}`} className= " relative w-full flex items-center justify-between gap-x-8">
                                {getCategoryName(child, i18n.language)}
                                {/* Only show arrow if child has sub-children */}
                                {child.childrens && child.childrens.length > 0 && (
                                <ArrowRightIcon className="text-sm text-[#2858a3] absolute -right-1 " />
                                )}
                            </Link>
                            {child.childrens && child.childrens.length > 0 && subChildCategories(parentSlug, childSlug, child.childrens)}
                        </Dropdown.Item>
                    );
                })}
            </Dropdown.Submenu>
        )
    );

    const subChildCategories = (parentSlug, childSlug, subChildrens) => (
        subChildrens.length > 0 && (
            <>
                <Dropdown.Submenu position="right" className="border-b-[3px] rounded-b-md bg-[#f1f1f1]" style={{ width: '160%', maxHeight: '320px', overflowY: 'auto', scrollbarWidth: 'thick' }}>
                 
                    {subChildrens.map((child, index) => {
                        const subChildSlug = child.slug || createSlug(child.name);
                        return (
                            <Dropdown.Item key={`subchild-${index}`} className="flex items-center justify-between gap-x-10">
                                <Link to={`/category/${parentSlug}/${childSlug}/${subChildSlug}`} className="w-full flex items-center justify-between gap-x-14">
                                    {getCategoryName(child, i18n.language)}
                                </Link>
                            </Dropdown.Item>
                        );
                    })}
                </Dropdown.Submenu>
            </>
        )
    );

    return (
        <Dropdown
            key={`${dropdownKey}-${i18n.language}`}
             sx={{
              fontSize: { md: "0.7rem", lg: "0.85rem", xl: "1rem" },
              px: { md: 0.5, lg: 1 },
              py: 0.5,
              whiteSpace: "nowrap",
            }}
            position="right"
          title={
  <div className="flex items-center">
    <Typography
      className="poppins text-white"
      sx={{
        fontSize: { md: "0.7rem", lg: "0.85rem", xl: "1rem" },
        px: { md: 0.5, lg: 1 },
        py: 0.5,
        whiteSpace: "nowrap",
      }}
    >
      {t("header_categories.shop")}
    </Typography>

    {categoryOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
  </div>
}
            className="poppins  text-white flex items-center relative px-3 py-2 rounded-lg transition-all duration-300 hover:bg-white/20 hover:shadow-lg hover:scale-105 group"
            onClick={() => setCategoryOpen(!categoryOpen)}
            menuClassName="border-b-[3px] rounded-b-md bg-[#f1f1f1] text-black h-fit absolute z-50 top-9 left-0 block"
        >
            <Dropdown.Item className="w-full flex items-center justify-between gap-x-14">
                <Link to={`/category`} className="w-full flex items-center justify-between gap-x-14">
                   {t("header_categories.view_all_items")}
                </Link>
            </Dropdown.Item>

            <Dropdown.Item className="w-full flex items-center justify-between gap-x-14">
                <>
                    {t("header_categories.categories")}
                    <ArrowRightIcon className="text-sm text-[#2858a3]" />
                    <Dropdown.Submenu position="right" className="border-b-[3px] rounded-b-md bg-[#f1f1f1]" style={{ width: '100%' }}>
                  
                        {categories.map((cat, i) => {
                            const catSlug = cat.slug || createSlug(cat.name);
                            return (
                                <Dropdown.Item key={i} className="w-full flex items-center justify-between gap-x-14 ">
                                    <Link to={`/category/${catSlug}`} className="w-full flex items-center justify-between  gap-x-10">
                                        {getCategoryName(cat, i18n.language)}
                                        {/* Only show arrow if category has children */}
                                        {cat.childrens && cat.childrens.length > 0 && (
                                        <ArrowRightIcon className="text-sm text-[#2858a3] " />
                                        )}
                                    </Link>
                                    {childCategories(catSlug, cat.childrens)}
                                </Dropdown.Item>
                            );
                        })}
                    </Dropdown.Submenu>
                </>
            </Dropdown.Item>

            <Deals key="deals-section" title={t("header_categories.deals").toUpperCase()} />
        </Dropdown>
    );
};

export default Categories;
